// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderCancellation\ApiPilotJobOrderCancellation.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';

// PilotJobOrderCancellationData is the class that PilotJobOrderCancellation serializes to/from
export interface PilotJobOrderCancellationData {
    Id : number;
	
    ChangeId : number;
    Event : EventData | null;
    EventId : number;
    PilotJobOrder : PilotJobOrderData | null;
    PointInTime : PilotJobOrderData | null;
	
    Remarks : string | null;
}

// PilotJobOrderCancellationOptions is the class which may be passed to the PilotJobOrderCancellation constructor to define optional initial data values
export interface PilotJobOrderCancellationOptions {
    Id : number;
	
    ChangeId? : number;
    Event? : EventOptions | null;
    EventId? : number;
    PilotJobOrder? : PilotJobOrderOptions | null;
    PointInTime? : PilotJobOrderOptions | null;
	
    Remarks? : string | null;
}

export class PilotJobOrderCancellation {
    public Id : DataSignal<number>;
	
    public ChangeId : DataSignal<number>;
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public PilotJobOrder : DataSignal<PilotJobOrder | null>;
    public PointInTime : DataSignal<PilotJobOrder | null>;
	
    public Remarks : DataSignal<string | null>;

    constructor();
    constructor(data : PilotJobOrderCancellationOptions);
    constructor(data: PilotJobOrderCancellationOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.PilotJobOrder = S.value<PilotJobOrder | null>(null);
        this.PointInTime = S.value<PilotJobOrder | null>(null);
	    
        this.Remarks = jsonableObservable(S.value<string | null>(data && data.Remarks !== undefined ? data.Remarks : null));
    }

    static key(obj : PilotJobOrderCancellation) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotJobOrderCancellationOptions) {
        return obj.Id;
    }

    static update(obj : PilotJobOrderCancellation, data : PilotJobOrderCancellationOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
	        
            if (data.Remarks !== undefined) obj.Remarks(data.Remarks);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotJobOrderCancellation.ts